<template>
    <div class="tab-pane fade show active position-relative" id="seo" role="tabpanel" aria-labelledby="seo-tab">
        <transition name="vue-table-loader">
            <div class="vue-details-loader" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <div class="product-form-tab">
            <product-lang-toggle></product-lang-toggle>
            <form action="">
                <div class="form-element-container">
                    <div v-for="group in productSeo.items">
                        <div class="row">
                            <div class="col-md-12 clearfix">
                                <h3>{{group.groupingName}}</h3>
                            </div>
                        </div>
                        <input-loader :fields="group.groupItems"></input-loader>
                    </div>
                </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-crud-controls">
                    <button v-on:click="saveSeoData()" type="button" class="btn btn-primary" v-if="$parent.permissionAllowed('manage_products') && $parent.permissionAllowed('manage_seo')">Update</button>
                  </div>
                </div>
              </div>
            </form>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import InputLoader from '../form/form-loader.vue';
    import productLangToggle from './product-language-select.vue';

    Vue.use(VueEvents)

    export default {
        name: 'product-seo',
        props: ['productDetails'],
        components:{
            'product-lang-toggle': productLangToggle,
            'input-loader': InputLoader,
        },
        data() {
            return {
                uiStates: {
                    errorMessage: null,
                    showLoading: true
                },
                product: this.productDetails,
                productSeo: {
                    items: {
                        groupingName: 'SEO',
                        groupItems: [

                        ]
                    }
                },
            }
        },
        beforeMount() {
            if(this.$parent.productSeo) {
                this.loading = false;
            }
        },
        mounted() {
        },
        created() {
            if( this.$parent.loadedPanelData.seo) {
                this.productSeo = this.$parent.productSeo;
                this.uiStates.showLoading = false;
            }
            if( ! this.$parent.loadedPanelData.seo) {
                this.loadProductSeo();
                this.$parent.loadedPanelData.seo = true;
            }
        },
        watch: {
            '$parent.languages.active': 'checkLangChange',
        },
        methods: {
            checkLangChange () {
                 this.uiStates.showLoading = true;
                 this.productSeo = [];
                 this.loadProductSeo();
            },
            loadProductSeo: function () {
                axios.get(base_url+ '/pimapi/products/'+this.product.info.id+'/product-seo/' + this.$parent.languages.active, {
                    // 'criteria': criteria,
                })
                    .then(function (response) {
                        this.productSeo = response.data.payload.seoData;
                        this.$parent.productSeo = this.productSeo;
                        this.uiStates.showLoading = false;
                    }.bind(this))
                    .catch(function (error) {
                        this.uiStates.showLoading = false;
                        this.$parent.alert.status = "alert-danger";
                        this.$parent.alert.message = error.response.data.message;
                    }.bind(this));
            },
            saveSeoData: function () {
                this.uiStates.showLoading = true;
                axios.post(base_url + '/pimapi/products/' + this.product.info.id + '/product-seo/' + this.$parent.languages.active, {
                    'data': this.productSeo,
                })
                .then(function(response) {
                    this.$parent.alert.status = "alert-success";
                    this.$parent.alert.message = "Product successfully saved";
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.showLoading = false;
                    this.$parent.alert.status = "alert-danger";
                    this.$parent.alert.message = error.response.data.message;
                }.bind(this));
            }
        }
    };
</script>

<style scoped lang="scss">
    .form-element-container {
        .form-group {
            margin-top: 0 !important;
        }
    }
</style>
